<template>
      <div class="mobile-app-area">
        <div class="container">
            <div class="row align-items-center left-side-flex">

                <div class="col-lg-6 col-md-12">
                    <div class="about-img">
                        <img src="../../assets/images/Digital-Marketing.png" data-aos="fade-up" alt="Digital-Marketing"
                            class="aos-init aos-animate">
                    </div>
                </div>
                <div class="col-lg-6 col-md-12">
                    <div class="about-content"><span class="sub-title text-uppercase">Marketing & Analytics</span>
                        <h2>Digital Marketing & Analytics</h2>
                        <p>Our marketing strategies go beyond basic targeting we use AI analytics to predict trends,
                            optimize ad spend, and personalize customer outreach. Every decision is backed by real-time,
                            data-driven insights.</p>
                        <div class="features-text"> 
                            <h6>Industries</h6>
                            <p> eCommerce, hospitality, SaaS, education, and more.</p>
                               <h6>Key Benefits</h6>
                            <p>Smarter targeting, improved ROI, predictive customer insights, campaign
                                optimization.</p>
                            <h6>Technologies</h6>
                            <p>
                            Google Analytics 4, SEMrush, HubSpot, Meta Ads AI Tools, Python, Power BI,
                                Google Cloud AI.
                            </p> 
                            <button data-v-b4360fc6="" class="default-btn ms-2" style="margin-left:0px !important;">Explore Solutions</button>
                        </div>

             
                    </div>
                </div>





            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: "MarketingService",
};
</script>